<style xmlns="http://www.w3.org/1999/html">
.header-home-nav, .home-footer {
  background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
  padding-bottom: 10px;
}

</style>

<template>
  <div>
    <div class="container-fluid blue-letters-girl">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumbs">
              <a href="/">Главная</a> / Полугодовой курс по развитию памяти и внимания
            </div>

            <h1>Полугодовой курс по развитию памяти и внимания</h1>

            <h3>для детей от 7 до 15 лет.</h3>
            <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                src="~@/assets/hometeacher/images/mnemomozg-mob.jpg"
                alt="Годовой курс Мнемотехника" class="mobile girl-notik"></div>
            <p>Мы научим ребенка запоминать разную информацию с помощью специальных техник.  Уроки-эпизоды и живые онлайн-занятия с преподавателем помогут ему в этом.</p>

            <p><span class="strong-black">Курс по Мнемотехнике поможет увеличить объем памяти вашего ребенка, он научится запоминать разную информацию с помощью специальных техник, а также концентрировать свое внимание на конкретном упражнении или действии. В учебе и жизни ему это обязательно пригодится!</span>
            </p>

            <p>Уроки-эпизоды базируются на поэтапном усложнении заданий. Каждый урок предполагает закрепление техник с помощью онлайн-тренажеров. Занятия чередуются с индивидуальными онлайн-консультациями тренера по мнемотехнике.</p>

            <p class="desktop-vers"><span class="blue-fon-text">Личный куратор будет направлять ребенка, решать</span><br>
              <span class="blue-fon-text">индивидуальные проблемы, связанные с запоминанием </span><br>
              <span class="blue-fon-text">информации, и контролировать процесс обучения.</span>
            </p>

            <p class="mobile-vers">
              <span class="blue-fon-text">Личный куратор будет</span><br>
              <span class="blue-fon-text">направлять ребенка,</span><br>
              <span class="blue-fon-text">решать индивидуальные</span><br>
              <span class="blue-fon-text">проблемы, связанные</span><br>
              <span class="blue-fon-text">с запоминанием информации,</span><br>
              <span class="blue-fon-text">и контролировать</span><br>
              <span class="blue-fon-text">процесс обучения.</span></p>
            <div class="knpk"><a href="https://poliglotiki.com/home-teacher/lesson/1001">Подать заявку</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid vkurs">
      <div class="container">
        <div class="row mobile-vers">
          <div class="col-12">
            <input type="checkbox" id="check">
            <label for="check"><h2 class="iba">Курс "Мнемотехника"</h2>
              <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
            <div class="block">
              <img src="~@/assets/hometeacher/images/mnemo-tatyana.jpg"
                   alt="Годовой курс Мнемотехника">
              <div>
                <p style="font-size: 3px;">&nbsp;</p>
                <div class="chek"></div>
                <p><span class="strong-black">26 уроков-эпизодов</span> для детей продолжительностью 30 минут каждый</p>
                <div class="chek"></div>
                <p><span class="strong-black">60 онлайн-тренажеров</span></p>
                <div class="chek"></div>
                <p><span class="strong-black">80 рабочих листов</span></p>
                <div class="chek"></div>
                <p><span class="strong-black">30</span> дополнительных <span class="strong-black">материалов на карточках</span></p>
                <p style="font-size: 3px;">&nbsp;</p>
                <div class="red-chek"></div>
                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
                </p>
                <div class="red-chek"></div>
                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
                </p>
                <p>оценка качества запоминания информации, выявление причин низкой внимательности, составление плана занятий</p>
                <div class="red-chek"></div>
                <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
                </p>
              </div>
              <h3>Длительность всего курса: 5-6 месяцев. </h3>
            </div>
          </div>
        </div>
        <div class="row desktop-vers">
          <div class="col-12">
            <h2 class="iba desktop-vers">Курс "Мнемотехника"</h2>

            <img src="~@/assets/hometeacher/images/mnemo-tatyana.jpg"
                 alt="Годовой курс Мнемотехника">

            <div class="chek"></div>
            <p><span class="strong-black">26 уроков-эпизодов</span> для детей продолжительностью 30 минут каждый</p>
            <div class="chek"></div>
            <p><span class="strong-black">60 онлайн-тренажеров</span></p>
            <div class="chek"></div>
            <p><span class="strong-black">80 рабочих листов</span></p>
            <div class="chek"></div>
            <p><span class="strong-black">30</span> дополнительных <span class="strong-black">материалов на карточках</span></p>
            <p style="font-size: 3px;">&nbsp;</p>
            <div class="red-chek"></div>
            <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
            </p>
            <div class="red-chek"></div>
            <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
            </p>
            <p>оценка качества запоминания информации, выявление причин низкой внимательности, составление плана занятий</p>
            <div class="red-chek"></div>
            <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
            </p>

            <h3>Длительность всего курса: 5-6 месяцев.</h3>
          </div>

        </div>
      </div>
    </div>

    <div class="container-fluid skytop"></div>
    <div class="container-fluid skyfon">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2>Мнемотехника от<br>
              “Полиглотиков” &ndash;
              <br>
              <span class="veselo">по эффективной методике!</span></h2>
            <p>Перед началом занятий тренер по мнемотехнике проведет первую консультацию,
              чтобы понять, по каким причинам ребенок плохо запоминает информацию, не умеет концентрировать свое внимание.
              При личном контакте мы сумеем заинтересовать ребенка. Выяснив причины, тренер вместе с родителем составляет индивидуальный план занятий.
              Первый бесплатный урок-эпизод и входная диагностика продемонстрируют, как мы учим, какие онлайн-тренажеры,
              карточки для скачивания вы будете использовать.</p>
          </div>

          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/strlka.png">
            <div class="knpk-yellow"><a href="https://poliglotiki.com/home-teacher/lesson/1001">Попробовать
              бесплатно</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid skydown"></div>

    <div class="container-fluid blue-letters-back">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="desktop-vers">Ставьте цели и <span class="viborabonement">выбирайте абонемент:</span>
            </h2>
            <h2 class="mobile-vers">Ставьте цели<br>
              <div class="viborabonement">и выбирайте<br> абонемент:</div>
            </h2>
          </div>
        </div>

        <StudyProductSubscriptionList
            :subscriptions="subscriptions"
            @order="orderSubscription"
        />

      </div>
    </div>

    <div class="container-fluid obuchenie">
      <div class="container">
        <div class="row mobile-vers">
          <div class="col-12">
            <input type="checkbox" id="check1">
            <label for="check1"><h2 class="iba">Как проходит обучение</h2>
              <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
            <div class="block">
              <div class="row">
                <div class="col-12 col-sm-3">
                  <div class="strela strelheight1"></div>
                  <div class="bluekrug">1</div>
                  <p style="padding-left: 70px;">Подайте заявку на <span class="strong-black">онлайн-консультацию с тренером</span>,
                    который <span class="strong-black">оценит уровень развития памяти и внимания</span>, проведет тестирование и даст рекомендации</p>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="strela strelheight2"></div>
                  <div class="bluekrug">2</div>
                  <p>Каждую неделю ученик проходит по <span class="strong-black">2 урока-эпизода</span>.</p>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="bluekrug">3</div>
                  <p>Во время занятия следует <span class="strong-black">выполнять все задания преподавателя</span>.
                    И регулярно тренироваться дома предложенными способами.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-3">
                  <div class="strela strelheight2"></div>
                  <div class="bluekrug">4</div>
                  <p><span class="strong-black">Заниматься на</span> онлайн-тренажерах регулярно несколько раз в неделю.</p>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="strela strelheight2"></div>
                  <div class="bluekrug" style="margin-bottom: 65px;">5</div>
                  <p>Ежемесячно наставник проводит <span class="strong-black">онлайн-встречи</span> с ребенком и родителями для контроля достижения результатов.</p>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="bluekrug">6</div>
                  <p><span class="strong-black">Получите поддержку 7/24 в чате</span>, задавая любые вопросы.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="row desktop-vers">
          <div class="col-12">
            <h2>Как проходит обучение</h2>
          </div>
        </div>
        <div class="row desktop-vers">
          <div class="col-12 col-sm-3">
            <div class="strela strelheight1"></div>
            <div class="bluekrug">1</div>
            <p>Подайте заявку на <span class="strong-black">онлайн-консультацию с тренером</span>,
              который <span class="strong-black">оценит уровень развития памяти и внимания</span>, проведет тестирование и даст рекомендации</p>
          </div>
          <div class="col-12 col-sm-3">
            <div class="strela strelheight2"></div>
            <div class="bluekrug">2</div>
            <p>Каждую неделю ученик проходит по <span class="strong-black">2 урока-эпизода</span>.</p>
          </div>
          <div class="col-12 col-sm-3">
            <div class="bluekrug">3</div>
            <p>Во время занятия следует <span class="strong-black">выполнять все задания преподавателя</span>. И регулярно тренироваться дома предложенными способами.</p>
          </div>
        </div>
        <div class="row desktop-vers">
          <div class="col-12 col-sm-9">
            <img src="~@/assets/hometeacher/images/strelka-krivaya.png" class="strelka-krivaya">
          </div>

          <div class="col-12 col-sm-3">
            <img src="~@/assets/hometeacher/images/hello.png" class="hello">
          </div>
        </div>
        <div class="row desktop-vers">
          <div class="col-12 col-sm-3">
            <div class="strela strelheight2"></div>
            <div class="bluekrug">4</div>
            <p><span class="strong-black">Заниматься на</span> онлайн-тренажерах регулярно несколько раз в неделю.
            </p>
          </div>
          <div class="col-12 col-sm-3">
            <div class="strela strelheight2"></div>
            <div class="bluekrug">5</div>
            <p>Ежемесячно наставник проводит <span class="strong-black">онлайн-встречи</span> с ребенком и родителями для контроля достижения результатов.</p>
          </div>
          <div class="col-12 col-sm-3">
            <div class="bluekrug">6</div>
            <p><span class="strong-black">Получите поддержку 7/24 в чате</span>, задавая любые вопросы.</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid liniya mobile-vers"></div>
    <div class="container-fluid white-bg no-shadow sm-video" style="padding-top: 0px; margin-top: 0px;">
    <div class="container align-middle" style="text-align: center;">
      <div class="row">
        <div class="col-12">
          <h2 style="margin-top: 40px; line-height: 1.3;">По окончании обучения<br>
            <span class="sertifikat">ребенок получает сертификат</span></h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="text-align: center;">
          <img src="~@/assets/hometeacher/images/sertifikat-mnemo.jpg">
        </div>
      </div>

    </div>
  </div>

    <div class="container-fluid bigwavetop desktop-vers"></div>
    <div class="container-fluid liniya mobile-vers"></div>

    <div class="container-fluid white-bg no-shadow sm-video">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <h2>Смотрите видео о наших курсах</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                    src="https://www.poliglotiki.ru/embed/X6zfVDRbyfg" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>

          </div>
        </div>



        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter desktop-vers"
                 style="margin-top: 70px; margin-bottom: -10px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid liniya mobile-vers"></div>

    <div class="container-fluid white-bg no-shadow sm-video">
      <div class="container align-middle">

        <div class="row">
          <div class="col-12">
            <h2>Отзывы родителей</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p style="margin-top: 0px;">Пока нет отзывов</p>
          </div>
        </div>
<!--
        <div class="row">
          <div class="col-12">
            <carousel :responsive="{0:{items:1},1000:{items:2}}">


              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/tatyana-tumanova.jpg">
                <span class="nameotzyv">Татьяна Туманова</span>
                <div class="text-otziv">Отличный курс. Ребёнку очень нравится. Все понятно и доступно.
                  Приятные преподаватели
                </div>
              </div>


              <div class="centers-text mx-3">
                <img class="photootzyv indotz" alt=""
                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                <span class="nameotzyv">Елена Серебрякова</span>
                <div class="text-otziv">Курс полезный, особенно, малышам которые занимаются в
                  Полиглотиках он-лайн и на очных занятиях. Так как он является словарной базой для
                  занятий, детей по ним обучают...
                </div>
              </div>


            </carousel>
          </div>
        </div>
        <div class="row" style="margin-top: 70px; margin-bottom: 50px;">
          <div class="col-12" style="text-align: center;">
            <a href="https://poliglotiki.com/home-teacher/course/anglijskij-s-rozhdeniya-part-1/details"
               class="allotzv">Читать все отзывы</a>
          </div>
        </div>
-->
      </div>
    </div>


    <div class="container-fluid skytop"></div>
    <div class="container-fluid skyfon">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-7">
            <h2>Мнемотехника от<br>
              “Полиглотиков” &ndash;
              <br>
              <span class="veselo">по эффективной методике!</span></h2>
            <p>Результат &ndash; ребенок научится запоминать до 30-40 картинок, слов, до 20 цифр подряд с помощью различных эйдо- и мнемотехник,
              а также станет более внимательным и усидчивым. Даже взрослым будет интересно! Присоединяйтесь!</p>
          </div>

          <div class="col-12 col-sm-5">
            <img src="~@/assets/hometeacher/images/strlka.png">
            <div class="knpk-yellow"><a href="https://poliglotiki.com/home-teacher/lesson/1001">Попробовать
              бесплатно</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid skydown-white desktop-vers"></div>
    <div class="container-fluid skydown mobile-vers"></div>
    <div class="container-fluid last-stav">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="desktop-vers">Ставьте цели и <span class="viborabon-last">выбирайте абонемент:</span>
            </h2>
            <h2 class="mobile-vers">Ставьте цели<br>
              <div class="viborabonement">и выбирайте<br> абонемент:</div>
            </h2>
          </div>
        </div>

        <StudyProductSubscriptionList
            :subscriptions="subscriptions"
            @order="orderSubscription"
        />

      </div>
    </div>

    <Entry/>

  </div>


</template>

<script>
import carousel from "vue-owl-carousel";
import moment from 'moment';
import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
import studyProductApi from "../data/StudyProductApi";
import StudyProductCourseList from "./Study/landing/StudyProductCourseList";
import Entry from "./Entry";
import courseApi from "../data/CourseApi";

export default {
  components: {
    StudyProductCourseList,
    StudyProductSubscriptionList,
    carousel,
    Entry,
  },
  name: "PolugodovojKursMnemotexnika",

  data: function () {
    return {
      title: null,
      slug: 'polugodovoj-kurs-mnemotexnika',
      subscriptions: [],
      freeSubscription: null,
      promoSuscription: null,
      courses: [],
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.loading = true

    studyProductApi.fetchStudyProductSlug(this.slug)
        .then(response => {
          this.subscriptions = response.subscriptions.filter(s => {
            if (s.price <= 0) {
              this.freeSubscription = s
              return false
            }
            return s.price > 0
          })
          this.courses = response.courses

        })
        .catch(error => {
          let data = error.response.data
          this.error = this.pretty(data)
          this.loading = false
        })

    /*courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-1')
        .then(response => {
            this.courses.push(response)
        })
        .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
        })

    courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-2')
        .then(response => {
            this.courses.push(response)
        })
        .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
        })

    courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-3')
        .then(response => {
            this.courses.push(response)
        })
        .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
        })*/
  },

  methods: {
    orderSubscription(subscription) {
      this.$router.push('/subscription/order/' + subscription.idsubscription)
    },
    aboutCourse(course) {
      this.$router.push('/course/' + course.slug + '/details')
    },
    tryFree() {
      if (this.freeSubscription) {
        this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
      }
    }
  },

  metaInfo() {
    return {
      title: 'Полугодовой курс по развитию памяти и внимания - Мнемотехника',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Полугодовой курс по развитию памяти и внимания для детей от 7 до 15 лет.'
        },
      ]
    }
  },
}
</script>

<style scoped>

.blue-letters-girl {
  background: url(~@/assets/hometeacher/images/mnemomozg.jpg) no-repeat center;
  text-align: left;
  box-shadow: inset 0 3px 5px #00000038;
  padding-top: 10px;
  min-height: 878px;
}

.breadcrumbs {
  font-size: 14px;
  background: #fff;
  max-width: 415px;
  padding-left: 7px;
  border-radius: 10px;
  margin-left: -7px;
}

.blue-letters-girl h1 {
  font-size: 43px;
  font-family: Manrope Black;
  margin-top: 15px;
  margin-bottom: -10px;
  color: #000;
  max-width: 818px;
  padding-top: 2px;
  padding-bottom: 10px;
  line-height: 1;
}

.blue-letters-girl h3 {
  font-size: 30px;
  font-family: Manrope Bold Alt;
  margin-bottom: 20px;
  color: #000;
}

.yellow-span {
  margin-left: 6px;
}

.blue-letters-girl p {
  font-size: 20px;
  max-width: 750px;
  line-height: 1.4;
}

.blue-fon-text {
  background: #00b4f1;
  color: #fff;
  border-radius: 15px;
  padding: 2px 10px;
  line-height: 1.8;
  font-size: 19px;
  font-family: 'Manrope Book';
  margin-left: 0px;
}

.knpk {
  border-radius: 35px;
  max-width: 230px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
  font-size: 22px;
  color: #fff;
  padding: 15px 30px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
  margin-top: 25px;
}

.knpk:hover {
  background: #49d92c;
}

.knpk a {
  color: #fff;
}

.vkurs {
  padding-top: 60px;
}

.vkurs h2 {
  font-size: 40px;
  font-family: Manrope Bold Alt;
  color: #262239;
  margin-bottom: 30px;
}

.vkurs h3 {
  font-size: 25px;
  font-family: "Manrope Bold";
  color: #231c37;
  margin-top: 30px;
}

.vkurs img {
  float: right;
  margin-right: -35px;
}

.vkurs p {
  font-size: 20px;
  margin-left: 35px;
  line-height: 1.4;
  color: #000;
  max-width: 635px;
}

.leftp {
  margin-left: 0px !important;
}

.red-chek {
  background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
  font-size: 20px;
  float: left;
  width: 25px;
  height: 20px;
  margin-top: 8px;
}

.bezlimit-group {
  background-image: url(~@/assets/hometeacher/images/bezlimit-group.png);
  line-height: 1.6 !important;
  padding-left: 8px;
  padding-bottom: 3px;
  padding-right: 8px;
  max-width: 589px !important;
}

.onlain-kons {
  background-image: url(~@/assets/hometeacher/images/onlain-kons.png);
  line-height: 1.4 !important;
  padding-left: 8px;
  padding-bottom: 0px;
  padding-right: 8px;
  max-width: 654px !important;
  padding-top: 2px;
}

.chek {
  background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
  font-size: 20px;
  float: left;
  width: 25px;
  height: 20px;
  margin-top: 8px;
}

.skytop {
  background: url(~@/assets/hometeacher/images/sunny-top.png) repeat center;
  width: 100%;
  height: 90px;
  margin-top: 50px;
}

.skydown {
  background: url(~@/assets/hometeacher/images/sunny-down.png) repeat center;
  width: 100%;
  height: 92px;
}

.skydown-white {
  background: url(~@/assets/hometeacher/images/sunny-down-white.png) repeat center;
  width: 100%;
  height: 93px;
}

.skyfon {
  background: #feb401;
  min-height: 350px;
  overflow: hidden;
  padding-bottom: 30px;
  padding-top: 30px;
}

.skyfon img {
  float: right;
  margin-right: -415px;
  margin-top: 165px;
  height: 33px;
  max-width: 100%;
}

.skyfon h2 {
  font-family: Manrope Bold Alt;
  font-size: 40px;
  color: #fff;
  margin-top: 50px;
  line-height: 1.3;
}

.skyfon p {
  color: #fff;
  font-size: 18px;
  line-height: 1.4;
  margin-top: 20px;
}

.veselo {
  background-image: url(~@/assets/hometeacher/images/eff-metod.png);
  padding-left: 8px;
  padding-top: 2px;
  padding-bottom: 9px;
  color: #000;
  padding-right: 10px;
}

.knpk-yellow {
  border-radius: 35px;
  text-align: center;
  max-width: 390px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
  font-size: 24px;
  padding: 15px 30px;
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
  margin-top: 150px;
}

.knpk-yellow:hover {
  background: #fbfe00;
}

.knpk-yellow a {
  color: #000;
}

.blue-letters-back {
  background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
  margin-top: 0;
  padding-bottom: 100px;
  text-align: left;
  padding-top: 70px;
}

.blue-letters-back h2 {
  font-size: 40px;
  font-family: "Manrope Black";
  color: #262239;
}

.viborabonement {
  background-image: url(~@/assets/hometeacher/images/viborabonement.png);
  padding-left: 8px;
  padding-top: 1px;
  padding-bottom: 8px;
  padding-right: 8px;
}


.abonement a {
  border-radius: 35px;
  max-width: 230px;
  font-family: Manrope Bold Alt;
  background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
  font-size: 20px;
  color: #fff;
  padding: 14px 35px;
  box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
  text-decoration: none;
}

.abonement a:hover {
  background: #49d92c;
}

.getpresent {
  box-shadow: inset 0 3px 5px #00000038;
  padding-top: 100px;
}

.getpresent h3 {
  font-size: 30px;
  font-family: Manrope Bold Alt;
  color: #262239;
  margin-bottom: 40px;
  text-align: center;
}

.bigwavetop {
  background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
  width: 100%;
  height: 190px;
}


.obuchenie {
  padding-top: 100px;
  padding-bottom: 40px;
  box-shadow: inset 0 3px 5px #00000038;
}

.obuchenie h2, .sm-video h2 {
  font-size: 40px;
  font-family: Manrope Bold Alt;
  color: #262239;
  margin-bottom: 60px;
}

.obuchenie p {
  font-size: 18px;
  width: 270px;
  line-height: 1.4;
}

.strela {
  background-image: url(~@/assets/hometeacher/images/strela.png);
  width: 176px;
  height: 19px;
  margin-top: 20px;
  left: 100px;
  position: absolute;
}

.bluekrug {
  width: 60px;
  height: 60px;
  border: 3px solid #00b4f1;
  border-radius: 50%;
  text-align: center;
  color: #4f4d5c;
  background: #fff;
  padding-top: 10px;
  font-size: 24px;
  font-family: "Manrope Bold";
  margin-bottom: 20px;
  position: relative;
  z-index: 10;
}

.strelka-krivaya {
  margin-left: 35px;
  margin-top: -40px;
  padding-bottom: 5px;
  max-width: 100%;
}

.hello {
  position: absolute;
  top: -150px;
  left: -20px
}

.sertifikat {
  background-image: url(~@/assets/hometeacher/images/sertifikat.png);
  padding-left: 8px;
  padding-top: 3px;
  padding-bottom: 8px;
  padding-right: 8px;
}

.sm-video {
  padding-top: 80px;
}

.sm-video p {
  margin-top: -100px;
  font-size: 18px;
  font-family: 'Manrope Book';
  color: #000;
  text-align: center;
}

.vidos {width:100%; height: 623px;}

.otzivh2 {
  font-size: 36px !important;
  font-family: "Manrope Black" !important;
  color: #231c37 !important;
  margin-bottom: 60px !important;
}

.indotz {
  float: left;
  margin-right: 20px;
  margin-bottom: 10px;
}

.nameotzyv {
  font-size: 21px;
  font-family: Manrope Bold;
  display: block;
  color: #000;
}

.text-otziv {
  font-size: 17px;
  color: #000;
  line-height: 1.4;
  margin-top: 10px;
}

.centers-text {
  max-width: 500px;
}

.allotzv {
  color: #0493c3;
  font-size: 20px;
  font-family: "Manrope Bold";
  padding: 15px 30px;
  border: 2px solid #0493c3;
  border-radius: 30px;
}

.allotzv:hover {
  background: #0493c3;
  color: #fff;
}

.viborabon-last {
  background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
  padding-left: 8px;
  padding-top: 1px;
  padding-bottom: 8px;
  padding-right: 8px;
}

.last-stav {
  padding-top: 70px;
  padding-bottom: 120px;
}

.last-stav h2 {
  font-size: 40px;
  font-family: "Manrope Bold Alt";
  color: #262239;
}

.girl-notik {
  margin-left: -25px;
  margin-bottom: 20px;
  max-width: 110%;
}

.liniya {
  background-image: url(~@/assets/hometeacher/images/liniya.png);
  width: 100%;
  height: 36px;
  margin-top: 30px;
}

@media (max-width: 1199px) {
  .obuchenie {
    overflow: hidden;
  }

  .hello {
    top: -110px;
    left: -115px;
  }
}

@media (max-width: 991px) {
  .abonement a {
    padding: 10px;
  }

  .centers-text {
    max-width: 100%;
    text-align: center;
  }

  .vidos {
    height: 370px;
  }

  .indotz {
    float: none;
    margin-bottom: 20px;
  }

  .blue-letters-girl h1 {
    background: none;
  }

  .bezlimit-group, .onlain-kons {
    background: none;
  }

  .obuchenie p {
    width: 100%;
  }

  .strela {
    display: none;
  }

  .hello {
    top: -160px;
  }
}

input[type="checkbox"] {
  display: none;
}

label {
  cursor: pointer;
  color: #fff;
  text-decoration: underline;
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  user-select: none;
}

.block {
  width: 100%;
  display: none;
}

input:checked ~ .block {
  display: block;
}

.galocka {
  margin-right: 0px !important;
  margin-top: -110px;
  float: right !important;
}
@media (max-width: 800px) {.vidos {height:400px;}}
@media (max-width: 750px) {
  .vidos {height:290px;}
}
@media (max-width: 575px) {
  .blue-letters-girl {
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-bottom: 60px;
    background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
  }

  .blue-letters-girl h1 {
    font-size: 34px;
    line-height: 1.1;
  }

  .blue-letters-girl h3 {
    font-size: 22px;
    margin-top: 10px;
  }

  .yellow-span {
    background-image: url(~@/assets/hometeacher/images/yellow-top-mob.png);
    font-size: 26px;
    padding-left: 8px;
    padding-top: 5px;
    padding-bottom: 11px;
    padding-right: 11px;
  }

  .vkurs {
    padding-left: 15px !important;
    padding-right: 15px !important;
    box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);
  }

  .vkurs h2 {
    font-size: 33px;
  }

  .vkurs img {
    float: none;
    max-width: 80%;
    margin-right: 0px !important;
  }

  .skyfon, .blue-letters-back {
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-top: 0px;
  }

  .skyfon h2 {
    font-size: 25px;
    line-height: 1.5;
  }

  .skyfon img {
    display: none;
  }

  .skytop {
    margin-top: 0px;
    margin-bottom: -1px;
  }

  .skydown, .skydown-white {
    margin-top: -1px;
  }

  .veselo {
    background-image: url(~@/assets/hometeacher/images/eff-metod-mob.png);
    padding-left: 8px;
    padding-top: 4px;
    padding-bottom: 10px;
    color: #000;
    padding-right: 10px;
    font-size: 22px;
  }

  .knpk-yellow {
    margin-top: 40px;
    font-size: 20px;
    padding: 15px;
  }

  .blue-letters-back h2, .last-stav h2 {
    font-size: 33px;
    text-align: center;
  }

  .viborabonement {
    background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
    width: 240px;
    line-height: 1.2;
    margin: 0 auto;
    padding-top: 1px;
    padding-bottom: 2px;
    margin-bottom: 30px;
    margin-top: -10px;
  }

  .getpresent {
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-top: 60px;
    text-align: center;
  }

  .obuchenie {
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-top: 25px;
    padding-bottom: 0px;
    margin-bottom: -20px
  }

  .obuchenie h2 {
    font-size: 33px;
  }

  .bluekrug {
    float: left;
    margin-right: 10px;
    margin-bottom: 42px;
  }

  .sm-video, .last-stav {
    padding-left: 15px !important;
    padding-right: 15px !important;
    padding-top: 0px;
  }

  .sm-video h2 {
    font-size: 30px;
  }

  .sertifikat {
    background: none;
    padding-left: 0px;
  }

  .vidos {height:294px;}

  .last-stav {
    background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
    padding-bottom: 0px;
  }
}
@media (max-width: 540px) {
  .vidos {height:284px;}
}
@media (max-width: 480px) {
  .vidos {height:251px;}
}
@media (max-width: 420px) {
  .vidos {height:218px;}
}
@media (max-width: 380px) {
  .vidos {height:193px;}
}
@media (max-width: 365px) {
  .veselo { padding-top: 8px; font-size: 18px;
    padding-bottom: 13px; border-radius: 30px;}
}
@media (max-width: 320px) {
  .vidos {height:165px;}
}

</style>
